import PropTypes from "prop-types";

import { CustomModal } from "./CustomModal";
import "./CustomConfirm.css";

export const CustomConfirm = ({
  visible,
  onConfirm,
  onCancel,
  title,
  description,
  children,
  width = 420,
  iconUrl = null,
  showCancel = true,
  caption = "Atención",
  okText = "Aceptar",
  cancelText = "Cancelar",
  confirmLoading = false,
}) => {
  return (
    <CustomModal
      visible={visible}
      title={title}
      caption={caption}
      onClose={onCancel}
      onCancel={onCancel}
      onOk={onConfirm}
      okText={okText}
      cancelText={cancelText}
      width={width}
      centered
      compact={true}
      confirm={true}
      headerShown={false}
      okButtonProps={{
        loading: confirmLoading,
        disabled: confirmLoading,
      }}
      cancelButtonProps={{
        style: showCancel ? {} : { display: "none" },
        disabled: confirmLoading,
      }}
    >
      <div className="confirm-component">
        {iconUrl && (
          <div className="confirm-icon-wrapper">
            <img src={iconUrl} alt="icon" className="confirm-icon" />
          </div>
        )}

        {caption && <p className="confirm-caption">{caption}</p>}

        {description && <p className="confirm-description">{description}</p>}

        {children && <div className="confirm-extra">{children}</div>}
      </div>
    </CustomModal>
  );
};

CustomConfirm.propTypes = {
  visible: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconUrl: PropTypes.string,
  showCancel: PropTypes.bool,
  caption: PropTypes.string,
  okText: PropTypes.string,
  confirmLoading: PropTypes.bool,
  cancelText: PropTypes.string,
};
